import React from 'react';

function Contact() {
  return (
    <div className="contact-terminal">
      <div className="terminal-line" style={{ color: '#94a3b8', fontStyle: 'italic', marginBottom: '0.75rem' }}>
        ➜ ./contact.sh
      </div>
      
      <div className="contact-row">
        <div className="contact-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
        </div>
        <div className="contact-details">
          <span className="contact-label">Email:</span>
          <span className="contact-value">
            <a href={`mailto:${"jeremy" + "@benred.co.za"}`}>
              {"jeremy" + "@benred.co.za"}
            </a>
          </span>
        </div>
      </div>

      <div className="contact-row">
        <div className="contact-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path><rect x="2" y="9" width="4" height="12"></rect><circle cx="4" cy="4" r="2"></circle></svg>
        </div>
        <div className="contact-details">
          <span className="contact-label">LinkedIn:</span>
          <span className="contact-value">
            <a href="https://www.linkedin.com/in/jeremy-roy-52280269/" target="_blank" rel="noopener noreferrer">
              jeremy-roy-52280269
            </a>
          </span>
        </div>
      </div>
      
      <div className="terminal-line" style={{ color: '#22c55e', fontSize: '0.8rem', marginTop: '1rem', fontFamily: 'monospace' }}>
        ✓ Network connection open. Ready for message dispatch.
      </div>
    </div>
  );
}

export default Contact;
